<template>
	<div id="wrap">
		<div class="flex flex-end">
			<el-button type="primary" @click="handleAdd">新增</el-button>
		</div>

		<el-dialog
			title="企业参与国家标准或行业标准制定情况汇总表"
			:visible.sync="centerDialogVisible"
			width="66%"
			center
		>
			<el-form
				:model="formData"
				:rules="rules"
				ref="formData"
				class="demo-ruleForm"
				v-loading="loading"
			>
				<div>
					<div class="content">
						<!-- <p class="text">知识产权信息</p> -->
						<el-row type="flex" class="row-bg" justify="space-between">
							<el-col :span="11">
								<el-form-item
									label="标准名称"
									prop="highTechApprovalStandardsBO.standardName"
									label-width="40%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="formData.highTechApprovalStandardsBO.standardName"
										placeholder="请填写"
									></el-input>
									<!--                    <el-select v-model="formData.highTechApprovalStandardsBO.standardName">-->
									<!--                    <el-option-->
									<!--                      v-for="item in standardName"-->
									<!--                      :key="item.value"-->
									<!--                      :label="item.name"-->
									<!--                      :value="item.name"-->
									<!--                    ></el-option>-->
									<!--                  </el-select>-->
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="标准级别"
									prop="highTechApprovalStandardsBO.standardLevel"
									label-width="40%"
								>
									<!--                  <el-input-->
									<!--                    type="number"-->
									<!--                    v-model="formData.highTechApprovalStandardsBO.standardLevel"-->
									<!--                    placeholder="请填写"-->
									<!--                  ></el-input>-->
									<el-select
										v-model="formData.highTechApprovalStandardsBO.standardLevel"
									>
										<el-option
											v-for="item in standardLevel"
											:key="item.dictCode"
											:label="item.dictName"
											:value="item.dictCode"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="标准编号"
									prop="highTechApprovalStandardsBO.standardNumber"
									label-width="40%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="
											formData.highTechApprovalStandardsBO.standardNumber
										"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="参与方式"
									prop="highTechApprovalStandardsBO.participationWay"
									label-width="40%"
								>
									<el-select
										v-model="
											formData.highTechApprovalStandardsBO.participationWay
										"
									>
										<el-option
											v-for="dict in participationNationalStandardsFormulation"
											:key="dict.key"
											:label="dict.dictName"
											:value="dict.dictCode"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="证明材料(pdf)" prop="" label-width="40%">
									<el-upload
										ref="upload"
										class="upload-demo"
										:action="uploadImgUrl"
										:on-success="quillImgSuccess"
										:on-preview="handleView"
										:on-remove="handleRemove"
										:on-error="uploadError"
										:before-upload="beforeUpload"
										accept=".pdf"
										:data="{ moduleType: 21 }"
										:file-list="fileList"
									>
										<el-button size="small" type="primary">点击上传</el-button>
									</el-upload>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false" v-loading="loading"
					>返回</el-button
				>
				<el-button
					type="primary"
					@click="classSubmitForm"
					:disabled="disabled"
					v-loading="loading"
					>保存</el-button
				>
			</span>
		</el-dialog>

		<el-table
			class="table"
			:data="datas"
			:header-cell-style="{ background: '#F5F7FA' }"
			stripe
			:row-class-name="tableRowClassName"
		>
			<el-table-column label="序号" width="100" prop="date">
				<template slot-scope="scope">
					<span>{{ scope.$index + 1 }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="standardName" label="标准名称"> </el-table-column>
			<el-table-column
				prop="standardLevel"
				label="标准级别"
				:formatter="formatData"
			></el-table-column>
			<el-table-column label="标准编号" prop="standardNumber"></el-table-column>
			<el-table-column
				label="参与方式"
				prop="participationWayStr"
			></el-table-column>

			<el-table-column label="操作" width="140" fixed="right">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						class="green"
						@click="handleUpdate(scope.row.id)"
						>编辑</el-button
					>
					<el-button
						type="text"
						size="small"
						class="red"
						@click="handleDelete(scope.row.id)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div class="flex flex-end">
			<el-pagination
				class="pagination"
				background
				v-show="total > 0"
				:total="total"
				:current-page.sync="queryParams.pageNum"
				:page-size.sync="queryParams.pageSize"
				@current-change="getList"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	getDict,
	getModuleFiles,
	participateInNationalStandardDesignationQueryAll,
	participateInNationalStandardDesignationQuery,
	participateInNationalStandardDesignationSave,
	participateInNationalStandardDesignationDelete
} from "@/api/ChinaHigh";
import { selectDictLabel } from "@/toolUtil/common";

export default {
	name: "formulate",
	props: {
		id: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			// 数据
			datas: [],
			standardName: [
				{ name: "国家", value: 1 },
				{ name: "行业", value: 2 }
			],
			total: 0,
			loading: true,
			// 弹框
			centerDialogVisible: false,
			queryParams: {},
			formData: {
				highTechApprovalStandardsBO: {},
				fileBindVOList: []
			},
			rules: {
				"highTechApprovalStandardsBO.standardName": [
					{ required: true, message: "请输入标准名称", trigger: "blur" }
				],
				"highTechApprovalStandardsBO.standardLevel": [
					{ required: true, message: "请输入标准级别", trigger: "change" }
				],
				"highTechApprovalStandardsBO.standardNumber": [
					{ required: true, message: "请输入标准编号", trigger: "blur" }
				],
				"highTechApprovalStandardsBO.participationWay": [
					{ required: true, message: "请选择参与方式", trigger: "change" }
				]
			},
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
			fileList: [],
			participationNationalStandardsFormulation: {},
			disabled: false,
			standardLevel: []
		};
	},
	created() {
		this.init();
		this.handleQuery();
	},
	methods: {
		init() {
			getDict({ type: "standard_level" }).then(res => {
				this.standardLevel = res.data;
			});
		},
		formatData(row) {
			return selectDictLabel(this.standardLevel, row.standardLevel);
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.approvalId = this.id;
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 列表 */
		getList() {
			this.loading = true;
			participateInNationalStandardDesignationQueryAll(this.queryParams).then(
				res => {
					this.datas = res.data.records;
					this.total = res.data.total;
					this.loading = false;
				}
			);
		},
		chushi() {
			// 技术领域1
			getDict({
				type: "participation_national_standards_formulation",
				parentId: 0
			}).then(res => {
				this.participationNationalStandardsFormulation = res.data;
			});
			this.formData = {
				highTechApprovalStandardsBO: {},
				fileBindVOList: []
			};
			this.fileList = [];
			this.resetFiles("upload");
			this.resetForm("formData");
		},
		handleAdd() {
			this.chushi();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.chushi();
			participateInNationalStandardDesignationQuery(id, this.id).then(res => {
				this.formData.highTechApprovalStandardsBO = res.data;
				getModuleFiles({ moduleId: res.data.id, moduleType: 21 }).then(res => {
					this.formData.fileBindVOList = res.data;
					res.data.forEach(re => {
						this.fileList.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					});
				});
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.formData.highTechApprovalStandardsBO.approvalId = this.id;
			this.$refs["formData"].validate(valid => {
				if (valid) {
					participateInNationalStandardDesignationSave(this.formData).then(
						res => {
							if (res.code === "00000") {
								this.handleQuery();
								this.centerDialogVisible = false;
								this.msgSuccess(res.msg);
							}
						}
					);
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			var that = this;
			this.$confirm("是否确认删除研发开发费用吗?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return participateInNationalStandardDesignationDelete({
						approvalId: that.id,
						ids: [id]
					});
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		},
		typeFormat(row) {
			return this.selectDictLabel(
				this.isIntellectualPropertyType,
				row.isIntellectualProperty
			);
		},
		beforeUpload(file) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (suffix != "pdf") {
				this.msgError("只能上传pdf格式的文件");

				return false;
			} else {
				// this.loading = true;
			}
		},
		// 上传成功
		quillImgSuccess(res, file, fileList) {
			this.loading = false;
			// 如果上传成功
			if (res.code === "00000") {
				this.formData.fileBindVOList.push(res.data);
				this.msgSuccess("附件上传成功");
			} else {
				this.msgError("附件上传失败");
			}
			let status = "";
			fileList.some(res => {
				if (res.status != "success") {
					status = 1;
					return;
				}
			});
			if (status != 1) {
				this.disabled = false;
			}
		},
		// 图片删除
		handleRemove(file, fileList) {
			this.formData.fileBindVOList = [];
			fileList.forEach(res => {
				if (res.response == undefined) {
					this.formData.fileBindVOList.push(res);
				} else {
					this.formData.fileBindVOList.push(res.response.data);
				}
			});
		},
		// 富文本图片上传失败
		uploadError(err, file, fileList) {
			this.loading = false;
			if (fileList.length > 0) {
				let status = "";
				fileList.some(res => {
					if (res.status != "success") {
						status = 1;
						return;
					}
				});
				if (status != 1) {
					this.disabled = false;
				}
			} else {
				this.disabled = false;
			}
			// loading动画消失
			this.msgError("图片上传失败");
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}
.button_box {
	margin-top: 20px;
}
.button_box button {
	padding: 10px 60px;
}
.image {
	width: 100%;
	height: auto;
}
.select_box {
	display: flex;
	justify-content: space-between;
}
.select_box .el-select {
	width: 30% !important;
}
.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
}
.content .text {
	font-size: 13px;
	padding: 10px 20px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.accessory_box {
	width: 100%;
}
.accessory_box > div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0;
}

.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.el-table .cell {
	white-space: pre-line;
}
.el-select {
	width: 100%;
}
</style>
